import React, { FC } from 'react';

interface Props {
  className?: string;
  size?: number;
  color?: string;
}

export const MailDotIcon: FC<Props> = ({ className, size = 24, color = 'currentColor' }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3.33366 16.6667C2.87533 16.6667 2.48296 16.5036 2.15658 16.1772C1.83019 15.8508 1.66699 15.4584 1.66699 15.0001V5.00008C1.66699 4.54175 1.83019 4.14939 2.15658 3.823C2.48296 3.49661 2.87533 3.33341 3.33366 3.33341H11.7503C11.6948 3.61119 11.667 3.88897 11.667 4.16675C11.667 4.44453 11.6948 4.7223 11.7503 5.00008H3.33366L10.0003 9.16675L13.042 7.27092C13.2364 7.45147 13.4482 7.60772 13.6774 7.73967C13.9066 7.87161 14.1462 7.98619 14.3962 8.08342L10.0003 10.8334L3.33366 6.66675V15.0001H16.667V8.25008C16.9864 8.18064 17.285 8.08342 17.5628 7.95842C17.8406 7.83342 18.0975 7.68064 18.3337 7.50008V15.0001C18.3337 15.4584 18.1705 15.8508 17.8441 16.1772C17.5177 16.5036 17.1253 16.6667 16.667 16.6667H3.33366ZM15.8337 6.66675C15.1392 6.66675 14.5489 6.42369 14.0628 5.93758C13.5767 5.45147 13.3337 4.86119 13.3337 4.16675C13.3337 3.4723 13.5767 2.88203 14.0628 2.39591C14.5489 1.9098 15.1392 1.66675 15.8337 1.66675C16.5281 1.66675 17.1184 1.9098 17.6045 2.39591C18.0906 2.88203 18.3337 3.4723 18.3337 4.16675C18.3337 4.86119 18.0906 5.45147 17.6045 5.93758C17.1184 6.42369 16.5281 6.66675 15.8337 6.66675Z" />
    </svg>
  );
};
